module.exports = __webpack_public_path__ + "static/img/company2.2da0e115.svg";